import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { withAttrs } from 'utils/react';

export const Disclaimer = styled(withAttrs(Typography, { variant: 'label' }))`
  display: flex;
  justify-content: center;
  padding-top: 16px;
`;
